<template functional>
  <v-list-item :disabled="props.disabled" v-bind="data.attrs" v-on="listeners">
    <v-list-item-icon>
      <v-layout row>
        <v-icon :color="$options.color(props)">{{ props.icon }}</v-icon>
      </v-layout>
    </v-list-item-icon>
    <v-input :rules="props.rules" hide-details="auto">
      <v-list-item-content class="pb-0">
        <v-list-item-title :class="$options.textColor(props, 'numero')">
          {{ $options.getInternational(props.telephone.numero) }}
        </v-list-item-title>
        <v-list-item-subtitle :class="$options.textColor(props, 'libelle')"
          >{{ props.telephone.libelle }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-content class="pb-0" v-if="props.telephone.codePoste">
        <v-list-item-title :class="$options.textColor(props, 'codePoste')">
          {{ props.telephone.codePoste }}
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="props.telephone.codePoste"
          :class="$options.textColor(props, 'codePoste')"
          >Code poste
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-input>
    <v-list-item-icon>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon v-on="on" :color="$options.color(props, 'smsAccepte')">{{
            props.telephone.smsAccepte
              ? 'mdi-cellphone-message'
              : 'mdi-cellphone-message-off'
          }}</v-icon>
        </template>
        <span>{{
          props.telephone.smsAccepte ? 'SMS accepté' : 'SMS refusé'
        }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon v-on="on" :color="$options.color(props, 'confidentiel')">{{
            props.telephone.confidentiel ? 'mdi-eye-off' : 'mdi-eye'
          }}</v-icon>
        </template>
        <span>{{
          props.telephone.confidentiel
            ? 'Téléphone confidentiel'
            : 'Téléphone public'
        }}</span>
      </v-tooltip>
    </v-list-item-icon>

    <slot name="action" />
  </v-list-item>
</template>

<script>
function color(props, path) {
  if (!props.analyseDiff) return null;

  const c = props.analyseDiff.color[props.itemPath];
  return (
    c || (path ? props.analyseDiff.color[props.itemPath + '.' + path] : null)
  );
}

function textColor(props, path) {
  const c = color(props, path);
  if (c) return `${c}--text`;
  else return null;
}

import { getInternational } from './telephoneUtil.js';
import { defaultDiff } from '@/utils/diff.js';

export default {
  functional: true,
  props: {
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
    },
    itemPath: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'mdi-phone',
    },
    telephone: {
      type: Object,
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
  },
  data() {
    return {
      telephoneLocal: Object.assign({}, this.telephone),
    };
  },
  color,
  textColor,
  getInternational,
};
</script>
